import { RouteObject } from "react-router"
import UsuarioList from "./view/usuario.list"
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../config/data.types"
import { AccountCircle } from "@mui/icons-material"

export enum PathRotaUsuario {
    usuario = "/usuario"
}

const routerUsuario: RouteObject = {
    path: PathRotaUsuario.usuario,
    element: <UsuarioList/>,
}


export const navigationToUsuarioView = ()=> rotas.navigate(PathRotaUsuario.usuario)

export function startRouterUsuario(){
    const menu:MainMenu = {
        text:"Usuário do sistema",
        icon:<AccountCircle />,
        eventOnClick:navigationToUsuarioView
    }
    menuRotas.push(menu);
    return routerUsuario
}